import { configureStore } from '@reduxjs/toolkit'
import enquiryReducer from './slices/enquiry'

export default configureStore({
  reducer: {
    enquiry: enquiryReducer
  },
})